import React, {createContext, useContext} from 'react';
import {useChat} from '../hooks/useChat';
import type {ChatSession} from '../types/chatTypes';
import {observer} from "mobx-react-lite";

type ChatContextType = {
    sessions: ChatSession[];
    currentSession: ChatSession | null;
    isConnected: boolean;
    hasReceivedFinalMessage: boolean;
    isRestoringSession: boolean;
    isWaiting: boolean
    sendMessage: (content: string) => Promise<void>;
    selectSession: (session: ChatSession) => void;
    startNewChat: (initialMessage?: string) => void;
    createNewSession: () => Promise<ChatSession>;
    restoreSession: (sessionId: string) => Promise<ChatSession | null>;
};

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider: React.FC<{ children: React.ReactNode }> = observer(({children}) =>
    <ChatContext.Provider value={useChat()}>{children}</ChatContext.Provider>
)

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (context === undefined) {
        throw new Error('useChatContext must be used within a ChatProvider');
    }
    return context;
};
